import { render, staticRenderFns } from "./CustomerProfileNotes.vue?vue&type=template&id=a87e5d3e&scoped=true&"
import script from "./CustomerProfileNotes.vue?vue&type=script&lang=ts&"
export * from "./CustomerProfileNotes.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerProfileNotes.vue?vue&type=style&index=0&id=a87e5d3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87e5d3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAvatar,VBtn,VCardTitle,VImg,VList,VSheet,VSpacer,VTextarea})
